type ConfigTypes = {
  env: string;
  hosts: { apiHost: string };
  mobileAppUrl: string;
  googleAnalyticsTrackingId: string;
};

const Config: ConfigTypes = {
  env: `${process.env.REACT_APP_ENV || "development"}`,
  hosts: {
    apiHost: process.env.REACT_APP_API_HOST || "",
  },
  mobileAppUrl: process.env.REACT_APP_MOBILE_APP_URL || "",
  googleAnalyticsTrackingId:
    process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID || "",
};

export default Config;
